import { Box, Button } from "@mui/material";
import React from "react";
import { useHistory } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import SaveIcon from "@mui/icons-material/Save";
import { FormValues, Step } from "./BulkUpdate";
import { useFormikContext } from "formik";
import { isEmpty } from "ramda";
import { AxiosResponse } from "axios";
import { DynamicFieldProps } from "./steps/BulkUpdateData";
import { MRT_RowSelectionState } from "material-react-table";

interface ActionButtonsProps {
  selectedItems: MRT_RowSelectionState;
  isProcessing: boolean;
  activeStep: Step;
  updateResult?: AxiosResponse;
  updateFields: DynamicFieldProps[];
  isLoading: boolean;
  handleBack: () => void;
  handleNext: () => void;
  setShowConfirmation: (value: boolean) => void;
}

const classes = {
  root: {
    position: "sticky",
    bottom: 0,
    right: 0,
    padding: "10px",
    width: "100%",
    background: "var(--dmg-gray-100)",
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    borderTop: "1px solid var(--dmg-gray-200)",
  },
  btnWrapper: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  iconSize: {
    fontSize: "14px!important",
  },
};

const ActionButtons = (props: ActionButtonsProps) => {
  const {
    selectedItems,
    isProcessing,
    activeStep,
    updateResult,
    updateFields,
    isLoading,
    handleBack,
    handleNext,
    setShowConfirmation,
  } = props;

  const history = useHistory();
  const { errors, values, dirty, isValid } = useFormikContext<FormValues>();

  // check if all values are valid
  const checkValuesValidity = (
    values: FormValues,
    updateFields: DynamicFieldProps[]
  ) => {
    for (const field of values.fields) {
      if (field.name && field.value) {
        const updateField = updateFields.find(
          (updateField) =>
            updateField.name === field.name &&
            updateField.fieldType === "select"
        );
        if (updateField) {
          const option = updateField.options?.find(
            (option) => option.value === field.value
          );
          if (!option) {
            return false;
          }
        }
      }
    }
    return true;
  };

  const isDisabledSubmitBtn =
    !isEmpty(errors) ||
    isEmpty(values.fields) ||
    !dirty ||
    !isValid ||
    values.fields.some(
      (item) =>
        Object.keys(item).length === 0 ||
        item.name === "" ||
        item.value === "" ||
        !item.hasOwnProperty("value")
    ) ||
    !checkValuesValidity(values, updateFields);

  const renderBtn = (activeStep: Step) => {
    switch (activeStep) {
      case Step.Selecting:
        return (
          <Box sx={classes.btnWrapper}>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<ArrowBackIosIcon sx={classes.iconSize} />}
              onClick={() =>
                !isProcessing ? history.goBack() : setShowConfirmation(true)
              }
            >
              Exit
            </Button>
            {!isProcessing ? null : (
              <Button
                variant="contained"
                color="primary"
                endIcon={<ArrowForwardIosIcon sx={classes.iconSize} />}
                onClick={handleNext}
                disabled={isEmpty(selectedItems)}
              >
                Next
              </Button>
            )}
          </Box>
        );
      case Step.Updating:
        return (
          <Box sx={classes.btnWrapper}>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<ArrowBackIosIcon sx={classes.iconSize} />}
              onClick={handleBack}
            >
              Back
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              endIcon={<SaveIcon sx={classes.iconSize} />}
              disabled={isDisabledSubmitBtn}
            >
              Save
            </Button>
          </Box>
        );
      case Step.Result:
        return (
          <Box display="flex" justifyContent="end" alignItems="center">
            {isLoading ? null : (
              <>
                {updateResult?.status === 200 ? (
                  <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<ArrowBackIosIcon sx={classes.iconSize} />}
                    onClick={() => history.goBack()}
                  >
                    Exit
                  </Button>
                ) : (
                  <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<ArrowBackIosIcon sx={classes.iconSize} />}
                    onClick={handleBack}
                  >
                    Back
                  </Button>
                )}
              </>
            )}
          </Box>
        );
      default:
        return (
          <Button
            onClick={() => setShowConfirmation(true)}
            startIcon={<ArrowBackIosIcon sx={classes.iconSize} />}
          >
            Exit
          </Button>
        );
    }
  };

  return (
    <Box display="flex" justifyContent="space-between" sx={classes.root}>
      {renderBtn(activeStep)}
    </Box>
  );
};

export default ActionButtons;
